module.exports = __webpack_public_path__ + "img/logo-white.e1ba326c.png";